const initDynamicCollectionSet = () => {
  const slideshowEl = document.querySelector('.slideshow.main-slideshow');
  // --- CORRECTED ID ---
  const collectionSetWrapper = document.getElementById('dynamic-collection-wrapper');

  if (!slideshowEl || !collectionSetWrapper) {
    return; // Exit if the required sections aren't on the page.
  }

  const collectionItems = collectionSetWrapper.querySelectorAll('.dynamic-collection-item');

  // This function hides all collections and shows only the one that matches the active slide index.
  const updateVisibleCollection = (activeIndex) => {
    collectionItems.forEach((item) => {
      const itemIndex = parseInt(item.dataset.index, 10);
      if (itemIndex === activeIndex) {
        item.style.display = 'block';
      } else {
        item.style.display = 'none';
      }
    });
  };

  // Wait for the theme's slideshow to be ready.
  const waitForFlickity = setInterval(() => {
    const mainSlideshowInstance = typeof Flickity !== 'undefined' ? Flickity.data(slideshowEl) : undefined;
    
    if (mainSlideshowInstance) {
      clearInterval(waitForFlickity);

      // Listen for when a slide settles into place.
      mainSlideshowInstance.on('settle', () => {
        updateVisibleCollection(mainSlideshowInstance.selectedIndex);
      });
      
      // Also set the correct one on initial page load
      updateVisibleCollection(mainSlideshowInstance.selectedIndex);
    }
  }, 200);
};

document.addEventListener('DOMContentLoaded', initDynamicCollectionSet);